import OwTranslate from "../OwTranslate/OwTranslate";
import { IMinimumOrderDisplayAmounts } from "../../../services/MinimumOrderService";

type Props = {
    amounts: IMinimumOrderDisplayAmounts;
};

/**
 * "Minimum order is {minimum}. Add {shortfall} more to place this order." Shared by order entry and the
 * ecommerce cart / checkout; the caller supplies the wrapper styling.
 */
const MinOrderTotalNotice = (props: Props) => {
    return (
        <OwTranslate
            id={"min_order_total_not_met"}
            defaultMessage={"The minimum order total is {minimum}. Add {shortfall} more to place this order."}
            values={{ minimum: props.amounts.minimum, shortfall: props.amounts.shortfall }}
        />
    );
};

export default MinOrderTotalNotice;
